import {
  ACCOUNTS_OUTSIDE_ONLINE_URLS
} from 'lib/constants';


export const getProfileURL = () => ACCOUNTS_OUTSIDE_ONLINE_URLS.PROFILE;

export const getSettingsURL = () => ACCOUNTS_OUTSIDE_ONLINE_URLS.SETTINGS;

export const getSubscriptionURL = () =>
  ACCOUNTS_OUTSIDE_ONLINE_URLS.SUBSCRIPTION;
